<template>
  <a-layout-footer v-if="showFooter" style="text-align: center">
    Ant Design ©2018 Created by Ant UED
  </a-layout-footer>
</template>